import { Peer, PeerEvents, PeerEventsType } from "@domain";
import { RoomStreamingBloc } from "../RoomStreamingBloc";
import { SignalingService } from "../services";
import {
  AddDataChannelCommand,
  SendAnswerCommand,
  SendCandidateCommand,
  SendOfferCommand,
  TrackCommand
} from "./commands/peer";

export interface IPeerCommand {
  execute(e: CustomEvent<PeerEventsType>): void;
}

export class PeerHandler {
  private commands: Map<PeerEvents, IPeerCommand> = new Map();
  private constructor(
    private peer: Peer,
    bloc: RoomStreamingBloc,
    signalingService: SignalingService
  ) {
    this.commands.set(
      PeerEvents.SEND_OFFER,
      new SendOfferCommand(bloc, signalingService)
    );
    this.commands.set(
      PeerEvents.SEND_ANSWER,
      new SendAnswerCommand(bloc, signalingService)
    );
    this.commands.set(
      PeerEvents.ADD_DATA_CHANNEL,
      new AddDataChannelCommand(bloc, signalingService)
    );
    this.commands.set(
      PeerEvents.TRACK_EVENT,
      new TrackCommand(bloc, signalingService)
    );
    this.commands.set(
      PeerEvents.SEND_CANDIDATE,
      new SendCandidateCommand(bloc, signalingService)
    );
  }

  public subscribe() {
    const service = this.peer.getRtcService();
    const sendOfferCommand = this.commands.get(PeerEvents.SEND_OFFER);
    if (sendOfferCommand) {
      service.addEventListener(PeerEvents.SEND_OFFER, (e: Event) =>
        sendOfferCommand.execute(e as CustomEvent<PeerEventsType>)
      );
    }
    const sendAnswerCommand = this.commands.get(PeerEvents.SEND_ANSWER);
    if (sendAnswerCommand) {
      service.addEventListener(PeerEvents.SEND_ANSWER, (e: Event) =>
        sendAnswerCommand.execute(e as CustomEvent<PeerEventsType>)
      );
    }
    const addDataChannelCommand = this.commands.get(
      PeerEvents.ADD_DATA_CHANNEL
    );
    if (addDataChannelCommand) {
      service.addEventListener(PeerEvents.ADD_DATA_CHANNEL, (e: Event) =>
        addDataChannelCommand.execute(e as CustomEvent<PeerEventsType>)
      );
    }
    const trackCommand = this.commands.get(PeerEvents.TRACK_EVENT);
    if (trackCommand) {
      service.addEventListener(PeerEvents.TRACK_EVENT, (e: Event) =>
        trackCommand.execute(e as CustomEvent<PeerEventsType>)
      );
    }
    const sendCandidateCommand = this.commands.get(PeerEvents.SEND_CANDIDATE);
    if (sendCandidateCommand) {
      service.addEventListener(PeerEvents.SEND_CANDIDATE, (e: Event) =>
        sendCandidateCommand.execute(e as CustomEvent<PeerEventsType>)
      );
    }
  }

  public static create(
    peer: Peer,
    bloc: RoomStreamingBloc,
    signalingService: SignalingService
  ): PeerHandler {
    const handler = new PeerHandler(peer, bloc, signalingService);
    handler.subscribe();
    return handler;
  }
}
